/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Account from './Account';

const title = 'My Account';

function action(ctx, routeParams) {
  // const state = ctx.store.getState();
  // const userData = (state.session || {}).USER_DATA;
  // const modules = ((userData || {}).group || {}).modules || [];
  // const isSalon = !!(userData || {}).salon;
  // const sidebarKey = 'loyalty';
  // if (modules.includes('loyalty') && isSalon) {
  //   sidebarKey = 'clubskpLoggedInSalon';
  // } else if (modules.includes('loyalty') && userData) {
  //   sidebarKey = 'clubskpLoggedIn';
  // }
  return {
    chunks: ['loyalty'],
    title,
    component: (
      <Account
        title={title}
        siteId={routeParams.siteId}
        sidebarKey={'salondb'}
      />
    ),
    routeParams,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/client/site/account/index.js